module.exports = __webpack_public_path__ + "img/nav-chat.d05c8a58.svg";